"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordIdFieldValueGetter = void 0;
const safe_field_value_1 = require("../safe-field-value");
const primitives_1 = require("../type-checking/primitives");
class RecordIdFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, primitives_1.isStringValue)(fieldValue);
        };
    }
}
exports.RecordIdFieldValueGetter = RecordIdFieldValueGetter;
